import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-step-welcome',
  templateUrl: './step-welcome.component.html',
  styleUrls: ['./step-welcome.component.scss']
})
export class StepWelcomeComponent {
  @Output() onComecar = new EventEmitter<void>();

  comecar() {
    this.onComecar.emit();
  }
}
